import api from "./axios";
import type { LogislyLocationGroup } from "../types/logislyLocationGroup";

export type LogislyLocationGroupPayload = {
  name: string;
  logislyLocationIds: string[];
};

export const getLogislyLocationGroupsApi = async (): Promise<LogislyLocationGroup[]> =>
  (await api.get("/api/v1/logisly/location-groups")).data.data.groups;

export const createLogislyLocationGroupApi = async (
  payload: LogislyLocationGroupPayload,
): Promise<LogislyLocationGroup> =>
  (await api.post("/api/v1/logisly/location-groups", payload)).data.data.group;

export const updateLogislyLocationGroupApi = async (
  id: string,
  payload: LogislyLocationGroupPayload,
): Promise<LogislyLocationGroup> =>
  (await api.put(`/api/v1/logisly/location-groups/${id}`, payload)).data.data.group;

export const deleteLogislyLocationGroupApi = async (id: string): Promise<void> => {
  await api.delete(`/api/v1/logisly/location-groups/${id}`);
};
